import {createContext, useContext} from 'react';

export const TermsContext = createContext(false);

export function useTermsAccepted() {
    return useContext(TermsContext);
}
